// QRScannerComponent.jsx
import React from 'react';
import { Scanner  } from '@yudiel/react-qr-scanner';

/**
 * Reusable component for the QR code scanner.
 * * @param {object} props
 * @param {function} props.onScan - Handler for successful scan. Receives the result object.
 * @param {function} props.onError - Handler for scanning errors. Receives the error object.
 */
function QRScannerComponent({ onScan, onError }) {
  const containerStyle = {
    width: '100%',
    aspectRatio: '1 / 1', // Ensures a square viewing area
    border: '2px solid #007bff',
    borderRadius: '8px',
    overflow: 'hidden',
    maxWidth: '400px', // Optional: limit max size
    maxHeight: '400px', // Optional: limit max size
    margin: '0 auto'
  };

  return (
    <div style={containerStyle}>
      <Scanner 
        onScan={onScan} // Passes the decoded result back to the parent
        onError={onError} // Passes any errors back to the parent
        // Use environment (rear) camera by default for mobile
        constraints={{ 
          facingMode: "environment" ,// Advanced constraints
        }}
        scanDelay={500}
        videoStyle={{ objectFit: 'cover' }}
      />
    </div>
  );
}

export default QRScannerComponent;